<div class="contact">
    <div class="row">
        <a [href]="euCompLeagueLinks.discord" target="_blank">
            <img src="images/ecl-discord.png" alt="Discord Account">
            <div>EUCOMPLEAGUE</div>
        </a>
    </div>
</div>
